module.exports = __webpack_public_path__ + "static/media/taste-cup-image-og.de655fef.png";